import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgGuidanceUp = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		transform: "translate(2 2)",
		d: "M33.7474 0C34.9944 0 35.9977 1.00326 35.9977 2.25029V24.7532C35.9977 26.0003 34.9944 27.0035 33.7474 27.0035C32.5003 27.0035 31.4971 26.0003 31.4971 24.7532V7.67912L3.83724 35.339C2.95587 36.2203 1.53069 36.2203 0.658699 35.339C-0.21329 34.4576 -0.222667 33.0418 0.649322 32.1604L28.3092 4.50059H11.2351C9.98804 4.50059 8.98478 3.49733 8.98478 2.25029C8.98478 1.00326 9.98804 0 11.2351 0H33.738H33.7474Z"
	})
});
export default SvgGuidanceUp;
